export const DEVICE_MAP = [
  {
    deviceTypeName: [
      'Solis Lite (WA)',
      'Solis Lite Test',
      'Solis Lite',
      'E1 (WA)',
      'E1 WingAlpha',
      'E1 ETG',
    ],
    title: 'HomeFi Portable Wireless Router',
    image: '/images/products/portable-router-icon.png',
    largeImage: '/images/products/large-portable-router-image.png',
    billingIcon: '/images/products/portable-router-billing-icon.png',
    activationImagePath: '/images/activation/homefi-hotspot-activation.png',
    variantTitle: 'Portable Router',
    variantOptions: ['Portable Router', 'Hotspot'],
  },
  {
    deviceTypeName: [
      'LTE Router (WA)',
      'CPE Router',
      'SIMCom M.2 Module (WA)',
      'SIMCom M.2 Module',
      'SIM6600 M.2 (WA)',
      '',
    ],
    title: 'HomeFi LTE Internet Router',
    image: '/images/products/router-icon.png',
    largeImage: '/images/products/large-router-image.png',
    billingIcon: '/images/products/router-billing-icon.png',
    activationImagePath: '/images/activation/homefi-router-activation.png',
    variantTitle: 'LTE Router',
    variantOptions: ['LTE Router', 'LTE'],
  },
  {
    deviceTypeName: ['HomeFi Titan Internet Subscription'],
    title: 'HomeFi Titan Internet Router',
    image: '/images/products/titan-image.png',
    largeImage: '/images/products/titan-image.png',
    billingIcon: '/images/products/titan-image.png',
    activationImagePath: '/images/activation/titan-image.png',
    variantTitle: 'Plan',
    variantOptions: ['Plan', 'Plan'],
  },
  {
    deviceTypeName: ['HomeFi Edge 5G Monthly Internet Subscription'],
    title: 'HomeFi Edge 5G Monthly Internet',
    image: '/images/products/edge-image.png',
    largeImage: '/images/products/edge-image.png',
    billingIcon: '/images/products/edge-image.png',
    activationImagePath: '/images/activation/edge-image.png',
    variantTitle: 'Plan',
    variantOptions: ['Plan', 'Plan'],
  },
];
